const searchDefaultState = {
    restaurants: [],
    loading: true,
    error: false,
    filter: ''
};

export default (state = searchDefaultState, action) => {

    switch(action.type) {

        case 'LOAD_SEARCH_RESULT_RESTAURANTS':
            return {
                ...state,
                restaurants: action.restaurants,
                loading: false
            };

        case 'SEARCH_ERROR':
            return {
                ...state,
                loading: false,
                error: action.error
            };

        case 'SEARCH_LOADING_COMPLETE':
            return {
                ...state,
                loading: false
            };

        case 'SEARCH_RESET':
            return searchDefaultState;

        default:
            return state;
    }
};